/**
 * Promise wrapper around the shared http client for ``POST /customer-intents``.
 *
 * Rejections are ``Error`` instances whose ``detail`` carries the backend's
 * human-readable message (same contract as the feedback API) so callers can
 * surface ``err.detail`` directly in a toast.
 */
import { data_from_server_post } from '@/shared/http/client';
import { CUSTOMER_INTENT_SEND_FAILED_MESSAGE } from '../constants';

const toError = (detail, fallback) => {
    const message = typeof detail === 'string' && detail.trim() ? detail : fallback;
    const err = new Error(message);
    err.detail = message;
    return err;
};

/**
 * ``POST /customer-intents`` ``{features, autonomy_level, something_else, workspace}``
 * → ``{task_id, url}``. User email and platform URL are added server-side.
 */
export function createCustomerIntent({ features, autonomyLevel, somethingElse, workspace }) {
    return new Promise((resolve, reject) => {
        data_from_server_post(
            'customer-intents',
            {
                features: features ?? [],
                autonomy_level: autonomyLevel ?? null,
                something_else: somethingElse ?? '',
                workspace: workspace ?? null,
            },
            resolve,
            (detail) => reject(toError(detail, CUSTOMER_INTENT_SEND_FAILED_MESSAGE)),
        ).catch((e) => reject(toError(e?.detail || e?.message, CUSTOMER_INTENT_SEND_FAILED_MESSAGE)));
    });
}
